import { render, staticRenderFns } from "./tower.vue?vue&type=template&id=c457be28&scoped=true"
import script from "./tower.vue?vue&type=script&lang=js"
export * from "./tower.vue?vue&type=script&lang=js"
import style0 from "./tower.vue?vue&type=style&index=0&id=c457be28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c457be28",
  null
  
)

export default component.exports